// extracted by mini-css-extract-plugin
module.exports = {"buttonCarouselArrow":"ButtonCarouselArrow_buttonCarouselArrow__lv_pY","buttonIcon":"ButtonCarouselArrow_buttonIcon__1Eao9","disabled":"ButtonCarouselArrow_disabled__JCWE3"};